import Header from './components/Header';
import Hero from './components/Hero';
import About from './components/About';
import PracticeAreas from './components/PracticeAreas';
import HowWeWork from './components/HowWeWork';
import Contact from './components/Contact';
import Footer from './components/Footer';

export default function Home() {
  return (
    <main className="font-sans bg-[#F4F3EF] overflow-x-hidden">
      <Header />
      <Hero />
      <About />
      <PracticeAreas />
      <HowWeWork />
      <Contact />
      <Footer />

      {/* Floating WhatsApp Button */}
      <a
        href="https://wa.me/5567999210516"
        target="_blank"
        rel="nofollow noreferrer"
        aria-label="Falar pelo WhatsApp"
        className="fixed bottom-6 right-6 z-50 w-14 h-14 flex items-center justify-center bg-[#25D366] hover:bg-[#22c55e] rounded-full shadow-lg transition-all duration-300 hover:scale-110 cursor-pointer"
      >
        <i className="ri-whatsapp-line text-white text-3xl"></i>
      </a>
    </main>
  );
}
